module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-24.75184b33.png";